<template>
  <div class="appointment-development-component">
    <div class="form-group form-label-group">
      <select v-model="selectedDevelopment" class="form-control" name="development_id" id="development_id">
        <option :value="null">Select Development</option>
        <option v-for="(development,id) in appointmentDevelopments" :key="id" :value="id">
          {{ development }}
        </option>
      </select>
      <label for="development">Development</label>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedDate: null,
      loading: false,
      selectedDevelopment: null,
    };
  },
  props: {
    appointmentDevelopments: {
      type: [Object],
    },
    developmentId: {
      type: [Number],
      default: null,
    },
  },
  mounted() {
    this.selectedDevelopment = this.developmentId;
  },
  watch: {
    selectedDevelopment: function (val) {
      this.$root.$emit('updateDevelopmentId', val);
    },
  },
};
</script>
